/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-09-26 14:55:41
 * @LastEditors: sj
 * @LastEditTime: 2022-10-27 10:27:29
 */
export interface TenentSettinglable {
  id?: string
  zcShoperId?:any
}

export const ZHEJIANGhilistLmtpricTypeOptions = [
  { id: '0', name: '不区分医院级别' },
  { id: '1', name: '一级及以下' },
  { id: '202', name: '职工县级' },
  { id: '3', name: '三级' },
  { id: '303', name: '职工省级' },
  { id: '305', name: '居民省级' },
  { id: '9011', name: '职工限价' },
  { id: '9014', name: '公立医院改革省级限价' },
  { id: '9021', name: '居民限价' },
  { id: '9024', name: '公立医院改革市级限价' },
  { id: '9032', name: '公立医院改革县级限价' },
  { id: '9041', name: '县级公立医院一级' },
  { id: '905', name: '诊疗项目医保最高价(一档)' },
  { id: '9052', name: '非公立省级限价' },
  { id: '9061', name: '县级公立医院三级' },
  { id: '907', name: '诊疗项目医保最高价(三档)' },
  { id: '908', name: '诊疗项目医保最高价(四档)' },
  { id: '909', name: '医保谈判价格' },
  { id: '910', name: '中选价格' },
  { id: '911', name: '医保支付上限' },
  { id: '9115', name: '三级非公立' },
  { id: '935', name: '一级及以下非公立' },
  { id: '975', name: '二级非公立' },
  { id: '999126', name: '公立医院取消耗材加成一级及以下' },
  { id: '999138', name: '公立医院取消耗材加成三级' },
  { id: '107', name: '居民乡级' },
  { id: '2', name: '二级' },
  { id: '203', name: '居民县级' },
  { id: '302', name: '职工市级' },
  { id: '304', name: '居民市级' },
  { id: '901', name: '两病门诊药品限价' },
  { id: '9012', name: '诊疗项目政府指导价格(一档)' },
  { id: '902', name: '一般药品限价' },
  { id: '9022', name: '诊疗项目政府指导价格(二档)' },
  { id: '903', name: '诊疗项目政府指导价格(三档)' },
  { id: '904', name: '诊疗项目政府指导价格(四档)' },
  { id: '9042', name: '公立医院改革乡级限价' },
  { id: '9051', name: '立医院二级' },
  { id: '906', name: '诊疗项目医保最高价(二档)' },
  { id: '9062', name: '非公立市级限价' },
  { id: '9072', name: '非公立县级限价' },
  { id: '9082', name: '非公立乡级限价' },
  { id: '9091', name: '市级县改限价' },
  { id: '9101', name: '县级标准下浮20基础上上浮15' },
  { id: '9111', name: '县级标准下浮20基础上上浮10' },
  { id: '915', name: '一级及以下公立' },
  { id: '955', name: '二级公立' },
  { id: '995', name: '三级公立' },
  { id: '999132', name: '公立医院取消耗材加成二级' },
]

export const hilistLmtpricTypeOptions = [
  { id: '99027', name: '民营门诊限价' },
]
